import { getSitesByCustomerID } from '@/redux/actions/siteActions';
import { setCurrentSite } from '@/redux/reducers/sitesReducers';
import { SelectField } from '@/shared/components/form/CompanyDropdownSelect';
import { setLocalStorageData } from '@/utils/LocalStorage';
import { colorText } from '@/utils/palette';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { getLocalStorageData } from '@/utils/LocalStorage';
import { saveToSessionStorage } from '@/utils/SessionStorage';

function SuperAdminSiteDropdown() {
  const dispatch = useDispatch();

  const customerSites = useSelector((state) => state?.site?.sitesByCustomerID);
  const { customerName } = useSelector((state) => state?.customer);
  const customerID = useSelector((state) => state?.customer?.currentCustomer?.customerID);
  const siteID = useSelector((state) => state?.site?.currentSite?.key);
  const currentSite = useSelector((state) => state?.site?.currentSite);

  const [allCustomerSites, setAllCustomerSites] = useState([]);

  useEffect(() => {
    dispatch(getSitesByCustomerID(customerID));
  }, [customerID, customerName]);

  useEffect(() => {
    if (customerSites?.length >= 0) {
      const sites = customerSites?.map((a) => ({
        value: a?.siteID,
        label: a?.siteName,
        key: a?.siteID,
      }));

      setAllCustomerSites([{ value: 'all', label: 'All Sites', key: 'all' }, ...sites]);
    }
  }, [customerID, siteID, customerSites, currentSite]);

  const handleChange = (option) => {
    if (getLocalStorageData('tabsOpen') === 1) {
      setLocalStorageData('currentSiteID', option?.key);
    } else {
      saveToSessionStorage('currentSiteID', option?.key);
    }
    dispatch(setCurrentSite(option));
  };
  useEffect(() => {
    if (customerSites?.length === 1) {
      if (getLocalStorageData('tabsOpen') === 1) {
        setLocalStorageData('currentSiteID', customerSites[0]?.siteID);
      } else {
        saveToSessionStorage('currentSiteID', customerSites[0]?.siteID);
      }
      const selectionSiteID = {
        value: customerSites[0]?.siteID,
        label: customerSites[0]?.siteName,
        key: customerSites[0]?.siteID,
      };
      dispatch(setCurrentSite(selectionSiteID));
    } else {
      dispatch(setCurrentSite({ value: 'all', label: 'All Sites', key: 'all' }));
      if (getLocalStorageData('tabsOpen') === 1) {
        setLocalStorageData('currentSiteID', 'all');
      } else {
        saveToSessionStorage('currentSiteID', 'all');
      }
    }
  }, [customerID, customerSites.length]);

  return (
    <>
      {customerSites?.length <= 1 ? null : (
        <>
          <DropdownContainer>
            <CurrentSite>Current Site:</CurrentSite>
            <SelectField
              value={currentSite}
              name='selectedSites'
              options={allCustomerSites || ''}
              onChange={handleChange}
            />
          </DropdownContainer>
        </>
      )}
    </>
  );
}

export default SuperAdminSiteDropdown;

const DropdownContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: auto;
  height: 100%;
  margin-right: 40px;

  @media (max-width: 645px) {
    height: 60px;
    margin-right: 0px;
  }
`;
const CurrentSite = styled.div`
  color: ${colorText};
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  width: auto;
  margin-right: 10px;

  @media (max-width: 1000px) {
    display: none;
  }
`;
